<template>
    <FormItem prop="branch" ref="branch" label="Branch">
        <Select :value="value ? value.id : null"
                size="large"
                @on-change="onChange">
            <Option v-for="item in list"
                    v-if="!item.is_deleted || (item.is_deleted && value && value.id === item.id)"
                    :disabled="item.is_deleted"
                    :value="item.id"
                    :key="item.id">
                <template>{{item.name}}</template>
            </Option>
        </Select>
    </FormItem>
</template>

<script>
    import {Branch} from '../models/Branch'

    export default {
        props: {
            value: {
                type: Object,
            }
        },

        data() {
            return {
                list: []
            }
        },

        methods: {
            async reload() {
                let response = await new Branch().all();
                this.list = response.data || [];
            },

            onChange(id) {
                let filtered = this.list.filter(item => item.id === id);
                this.$emit('input', filtered.length ? filtered[0] : null)
            },
        },

        mounted() {
            this.reload()
        },
    }
</script>
